// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__10kQG","medium":"icon_medium__hR2en","dark":"icon_dark__2Ooe0","light":"icon_light__l-cOB","ghost":"icon_ghost__1E7Od","small":"icon_small__3iOF4"};